import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

export default function AuthModal({ open, setOpen, mode, setMode }) {
  const { login, register } = useAuth();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (mode === "login") {
        await login(form.email, form.password);
        toast.success("Welcome back!");
      } else {
        await register(form.name, form.email, form.password);
        toast.success("Account created");
      }
      setOpen(false);
      setForm({ name: "", email: "", password: "" });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Something went wrong");
    } finally { setLoading(false); }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="sm:max-w-md" data-testid="auth-modal">
        <DialogHeader>
          <DialogTitle className="font-heading text-2xl">
            {mode === "login" ? "Welcome back" : "Create your account"}
          </DialogTitle>
        </DialogHeader>
        <form onSubmit={onSubmit} className="space-y-4 mt-2">
          {mode === "register" && (
            <div>
              <Label>Full name</Label>
              <Input data-testid="auth-name-input" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
            </div>
          )}
          <div>
            <Label>Email</Label>
            <Input data-testid="auth-email-input" type="email" required value={form.email}
                   onChange={(e) => setForm({ ...form, email: e.target.value })} />
          </div>
          <div>
            <Label>Password</Label>
            <Input data-testid="auth-password-input" type="password" required minLength={6} value={form.password}
                   onChange={(e) => setForm({ ...form, password: e.target.value })} />
          </div>
          <Button data-testid="auth-submit-btn" disabled={loading} type="submit"
                  className="w-full bg-[var(--brand-primary)] hover:bg-[var(--brand-primary-dark)] rounded-full h-11">
            {loading ? "Please wait..." : mode === "login" ? "Sign in" : "Create account"}
          </Button>
          <p className="text-center text-sm text-slate-600">
            {mode === "login" ? "New here?" : "Have an account?"}{" "}
            <button data-testid="auth-toggle-mode" type="button" className="text-[var(--brand-primary)] font-medium hover:underline"
                    onClick={() => setMode(mode === "login" ? "register" : "login")}>
              {mode === "login" ? "Create account" : "Sign in"}
            </button>
          </p>
        </form>
      </DialogContent>
    </Dialog>
  );
}
